import React from 'react';
import { Container } from '@goodfynd/layout';
import Head from 'next/head';

import CmsPageContent from '../components/cms/CmsPageContent';
import { setPageTitle } from '../utils/base';

export default function Custom404() {
  return (
    <>
      <Head>
        <title>{setPageTitle('Oops 😭')}</title>
        <meta content="noindex, nofollow" name="robots" />
      </Head>

      <Container
        css={{
          '&.MuiContainer-root': {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            padding: 32,
          },
        }}
      >
        <CmsPageContent slug="consumer-404" />
      </Container>
    </>
  );
}
